// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ============================================================
   Payment Voucher Modal — Scoped Styles
   Follows the existing ERP design system (bluelight theme)
   ============================================================ */
.pv-modal {
  width: 100%;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
}

.pv-modal__header {
  background: linear-gradient(135deg, #f8f9ff 0%, #eef1ff 100%);
  border-bottom: 1px solid #e8ecff;
}

.pv-modal__title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1e1e2d;
}

.pv-modal__body {
  max-height: 70vh;
  overflow-y: auto;
}

.pv-modal__footer {
  border-top: 1px solid #e8ecff;
  background: #fafbff;
}

/* ── Invoice reference badge ─────────────────────────────── */
.pv-invoice-badge {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  background: #eef6ff;
  border: 1px solid #b8d9ff;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 0.85rem;
  color: #1a73e8;
  width: 100%;
}

.pv-invoice-badge__amount {
  margin-inline-start: auto;
  color: #0d6efd;
  font-weight: 600;
}

/* ── Inputs ──────────────────────────────────────────────── */
.pv-input {
  border-radius: 8px;
  border-color: #d6d9e2;
  font-size: 0.875rem;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.pv-input:focus {
  border-color: #3300ff;
  box-shadow: 0 0 0 3px rgba(51, 0, 255, 0.08);
}

.pv-input--sm {
  font-size: 0.82rem;
  padding: 0.3rem 0.6rem;
}

/* ── Line rows ───────────────────────────────────────────── */
.pv-lines-section {
  background: #f8f9fc;
  border-radius: 10px;
  padding: 16px;
  border: 1px solid #e8ecff;
}

.pv-lines-header {
  font-size: 0.9rem;
  color: #3d3d5c;
}

.pv-line-row {
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #e2e6f0;
}

/* ── Buttons ─────────────────────────────────────────────── */
.pv-btn {
  border-radius: 8px;
  min-width: 120px;
  font-weight: 500;
  font-size: 0.875rem;
  transition: all 0.2s;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/invoices/create-invoice/payment-voucher-modal/payment-voucher-modal.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;iEAAA;AAKA;EACE,WAAA;EAEA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,6DAAA;EACA,gCAAA;AAAF;;AAGA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,gBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,6BAAA;EACA,mBAAA;AAAF;;AAGA,+DAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;AAAF;;AAGA;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;AAAF;;AAGA,+DAAA;AACA;EACE,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,8CAAA;AAAF;;AAGA;EACE,qBAAA;EACA,4CAAA;AAAF;;AAGA;EACE,kBAAA;EACA,sBAAA;AAAF;;AAGA,+DAAA;AACA;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,cAAA;AAAF;;AAGA;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;AAAF;;AAGA,+DAAA;AACA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AAAF","sourcesContent":["/* ============================================================\n   Payment Voucher Modal — Scoped Styles\n   Follows the existing ERP design system (bluelight theme)\n   ============================================================ */\n\n.pv-modal {\n  width: 100%;\n  \n  background: #fff;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.pv-modal__header {\n  background: linear-gradient(135deg, #f8f9ff 0%, #eef1ff 100%);\n  border-bottom: 1px solid #e8ecff;\n}\n\n.pv-modal__title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #1e1e2d;\n}\n\n.pv-modal__body {\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.pv-modal__footer {\n  border-top: 1px solid #e8ecff;\n  background: #fafbff;\n}\n\n/* ── Invoice reference badge ─────────────────────────────── */\n.pv-invoice-badge {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px;\n  background: #eef6ff;\n  border: 1px solid #b8d9ff;\n  border-radius: 8px;\n  padding: 8px 14px;\n  font-size: 0.85rem;\n  color: #1a73e8;\n  width: 100%;\n}\n\n.pv-invoice-badge__amount {\n  margin-inline-start: auto;\n  color: #0d6efd;\n  font-weight: 600;\n}\n\n/* ── Inputs ──────────────────────────────────────────────── */\n.pv-input {\n  border-radius: 8px;\n  border-color: #d6d9e2;\n  font-size: 0.875rem;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.pv-input:focus {\n  border-color: #3300ff;\n  box-shadow: 0 0 0 3px rgba(51, 0, 255, 0.08);\n}\n\n.pv-input--sm {\n  font-size: 0.82rem;\n  padding: 0.3rem 0.6rem;\n}\n\n/* ── Line rows ───────────────────────────────────────────── */\n.pv-lines-section {\n  background: #f8f9fc;\n  border-radius: 10px;\n  padding: 16px;\n  border: 1px solid #e8ecff;\n}\n\n.pv-lines-header {\n  font-size: 0.9rem;\n  color: #3d3d5c;\n}\n\n.pv-line-row {\n  background: #fff;\n  border-radius: 8px;\n  padding: 12px;\n  border: 1px solid #e2e6f0;\n}\n\n/* ── Buttons ─────────────────────────────────────────────── */\n.pv-btn {\n  border-radius: 8px;\n  min-width: 120px;\n  font-weight: 500;\n  font-size: 0.875rem;\n  transition: all 0.2s;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
